import { batch } from 'react-redux';
import { push } from 'connected-react-router';

import { SET_ACCEPT_AGREEMENT_START, SET_ACCEPT_AGREEMENT_FULFILLED, SET_ACCEPT_AGREEMENT_REJECTED } from './actionTypes';

import { axiosAuthed } from '../../../shared/utils/setCommonHeaders';
import { showErrorToast } from '../../../shared/utils/toastManager';

const setAcceptAgreement = (accountCode) => (dispatch) => {
  dispatch({ type: SET_ACCEPT_AGREEMENT_START });
  axiosAuthed.post(`/accounts/${accountCode}/agree`)
    .then((response) => {
      setTimeout(() => {
        batch(() => {
          dispatch({
            payload: response.data,
            type: SET_ACCEPT_AGREEMENT_FULFILLED,
          });
          dispatch(push('/'));
        });
      }, 800);
    })
    .catch((error) => {
      dispatch({
        payload: error?.response?.headers?.message || 'An error has occurred accepting the user agreement.',
        type: SET_ACCEPT_AGREEMENT_REJECTED,
      });
      showErrorToast(error?.response?.headers?.message || 'An error has occurred accepting the user agreement.');
    });
};

export default setAcceptAgreement;
